import { render, staticRenderFns } from "./btn-primary.vue?vue&type=template&id=ff497934&scoped=true&"
import script from "./btn-primary.vue?vue&type=script&lang=js&"
export * from "./btn-primary.vue?vue&type=script&lang=js&"
import style0 from "./btn-primary.vue?vue&type=style&index=0&id=ff497934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff497934",
  null
  
)

export default component.exports